import { PayloadAction } from '@reduxjs/toolkit';

import { ProductPersonalizerState } from 'product-personalizer/src/store/productPersonalizer/slice';

const setSelectedPreviewIndexReducer = (state: ProductPersonalizerState, action: PayloadAction<number>) => {
  state.selectedPreviewIndex = action.payload;
};

export default setSelectedPreviewIndexReducer;
